<template>
    <nav id="navigation-overlay" :class="{ open: menuOpen }">
        <x-container fluid py-0 app-width>
            <x-layout>
                <x-flex>
                    <ul>
                        <li @click="closeNavigation()">
                            <router-link :to="dashboardLink">Dashboard</router-link>
                        </li>
                        <li @click="closeNavigation()" v-if="getAQuote">
                            <router-link to="/agent/risk/new">Get quotes</router-link>
                        </li>
                        <li @click="closeNavigation()" v-if="userIsPlacingBroker">
                            <router-link to="/agent/mst/new">Manual submission tracker</router-link>
                        </li>
                        <li @click="closeNavigation()" v-if="userIsInsurer || userIsCaptiveInsurer">
                            <router-link to="/insurer/reports">Reports</router-link>
                        </li>
                        <li @click="closeNavigation()" v-else>
                            <router-link to="/agent/reports">Reports</router-link>
                        </li>
                        <li @click="closeNavigation()" v-if="userIsInsurer">
                            <router-link to="/insurer/security">Securities</router-link>
                        </li>
                        <li @click="closeNavigation()" v-if="userIsBrokerAdmin">
                            <router-link to="/agent/insurer-entity">Insurer entity</router-link>
                        </li>
                    </ul>

                    <ul>
                        <li @click="logout">
                            <router-link to="/logout">Logout</router-link>
                        </li>
                    </ul>
                </x-flex>

                <x-flex v-if="!userIsInsurer">
                    <ul>
                        <li @click="closeNavigation()" v-if="userIsBrokerAdmin">
                            <router-link to="/agent/client-assignment">Client assignments</router-link>
                        </li>
                        <li @click="closeNavigation()" v-if="userIsBrokerAdmin">
                            <router-link to="/agent/client-and-entity-manager">Client & Entity manager</router-link>
                        </li>
                        <li @click="closeNavigation()" v-if="userIsPlacingBroker">
                            <router-link to="/agent/facility-manager">Facility manager</router-link>
                        </li>
                        <li @click="closeNavigation()" v-if="userIsBrokerAdmin">
                            <router-link to="/agent/obligors">Obligors</router-link>
                        </li>
                    </ul>
                </x-flex>
            </x-layout>
        </x-container>
    </nav>
</template>

<script>
    export default {
        props: ['menuOpen'],
        computed: {
            dashboardLink() {
                return this.$root.user.company && ['insurer', 'captive_insurer'].includes(this.$root.user.company.company_type) ? '/insurer/dashboard/' : '/agent/dashboard/';
            },
            getAQuote() {
                return this.$root.user.company && ['client', 'producing_broker', 'placing_broker'].includes(this.$root.user.company.company_type);
            },
            userIsBrokerAdmin() {
                return this.$root.userIsBrokerAdmin()
            },
            userIsPlacingBroker() {
                return this.$root.user.company && this.$root.user.company.company_type === 'placing_broker';
            },
            userIsInsurer() {
                return this.$root.user.company && this.$root.user.company.company_type === 'insurer';
            },
            userIsCaptiveInsurer() {
                return this.$root.user.company && this.$root.user.company.company_type === 'captive_insurer';
            }
        },
        methods: {
            logout() {
                sessionStorage.removeItem('tx-dashboard-filters');
                this.$hyperionAuth.logout();
            },
            closeNavigation() {
                this.$emit('closeNav');
            }
        }
    }
</script>

<style lang="scss" scoped>

    #navigation-overlay::-webkit-scrollbar {
    display: none;
    }

    #navigation-overlay {
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.5s, visibility 0s 0.5s;
        z-index: 4;
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-image: url("/assets/img/logo-bg.svg"),
                    radial-gradient(42.22% 83.5% at 26.53% 57.42%, rgba(224, 236, 137, 0.2) 0%, rgba(224, 236, 137, 0) 100%),
                    linear-gradient(116.55deg, #000000 0.39%, #173F35 100%);
        background-size: 100%;
        background-repeat: no-repeat;
        overflow-y: scroll;
        -ms-overflow-style: none;
        scrollbar-width: none;

        .flex {
            flex-grow: 0;
        }

        ul {
            list-style: none;
            padding: 0;
            position: relative;
            text-align: left;
            margin: 156px 0 128px 192px;

            li {
                display: block;
                line-height: 1em;
                text-shadow: none;
                color: #fff;
                transition: all 0.35s ease-out;
                opacity: 0;
                transform: scale(0.75) translateY(-24px);
                margin-bottom: 32px;

                a {
                    font-weight: 400;
                    display: block;
                    color: #fff;
                    transition: color 0.2s;
                    font-family: $font-title;
                    letter-spacing: rem(-1.68px);
                    font-size: rem(40px);
                    text-decoration: none;

                    &:hover,
                    &:focus {
                        color: $color-secondary;
                    }
                }

                @for $i from 1 through 10 {
                    &:nth-child(#{$i}) {
                        transition-delay: $i * 0.05s;
                    }
                }

            }
        }

        &.open {
            opacity: 1;
            visibility: visible;
            transition: none;

            ul {
                li {
                    opacity: 1;
                    transform: scale(1) translateY(0);
                }
            }
        }

        @media (min-width: 768px) {
            ul {
                li {
                    font-size: 2.875em;
                    line-height: 1.25em;
                }
            }
        }
    }
</style>
